const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 534 534",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M123.786,308.97c8.795,-36.313 6.885,-50.481 19.107,-116.412c4.017,-21.669 11.217,-46.949 13.845,-73.174c1.247,-12.442 -106.401,10.677 -134.998,57.812c-13.412,22.107 -18.69,-39.714 40.267,-94.015c19.471,-17.933 52.443,-37.426 83.08,-40.158c66.202,-5.902 251.655,7.692 314.136,4.742c21.564,-1.018 60.752,-22.442 60.752,-22.442c0,-0 4.562,53.591 -25.101,79.138c-9.903,8.529 -21.093,16.723 -38.651,19.131c-19.245,2.639 -44.693,-0.553 -49.736,9.023c-25.964,49.298 -38.351,148.154 -42.298,188.497c-16.398,167.636 72.293,122.364 112.177,40.313c2.193,-4.511 12.164,2.856 12.852,7.824c10.546,76.14 -63.935,148.577 -125.747,136.046c-58.652,-11.889 -92.065,-88.168 -75.178,-173.406c12.233,-61.746 45.719,-203.124 45.719,-203.124l-107.364,-8.306c-8.294,1.656 -39.07,243.902 -58.619,305.773c-25.4,80.385 -84.534,79.557 -106.918,72.997c-11.958,-3.505 -31.179,-22.737 -19.039,-39.425c7.451,-10.242 39.218,-25.064 48.052,-49.368c9.767,-26.871 25.274,-66.833 33.662,-101.466Z",
    style: {
      fill: "#83cdff",
      stroke: "#83cdff",
      strokeWidth: "4.17px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7ef90b868f346481e5fa01c263bd57ac.svg";
export { ForwardRef as ReactComponent };